export default {
  cards: {
    chart: {
      institusiFormal: {
        queryName: "institusi_pendi_formal",
        content: {
          title: "Jumlah Institusi Pendidikan Formal",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik jumlah insitusi pendidikan formal",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 450,
          },
          chartOption: {
            grid: {
              top: 20,
              left: 60,
              right: 30,
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            xAxis: {
              type: "value",
            },
            yAxis: {
              type: "category",
              data: [],
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Intitusi Pendidikan Formal",
              dataIndex: "pendidikan_formal",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      institusiNonFormal: {
        queryName: "institusi_pendi_nonformal",
        content: {
          title: "Jumlah Institusi Pendidikan Non Formal",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik jumlah insitusi pendidikan non formal",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 450,
          },
          chartOption: {
            grid: {
              top: 20,
              left: 60,
              right: 30,
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            xAxis: {
              type: "value",
            },
            yAxis: {
              type: "category",
              data: [],
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Intitusi Pendidikan Non Formal",
              dataIndex: "pendidikan_nonformal",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      jumlahPendidik: {
        queryName: "sebaran_jumlah_pendidik",
        content: {
          title: "Sebaran Jumlah Pendidik",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik sebaran jumlah pendidik",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: "100%",
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: {
              type: "value",
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                formatter: (value) => {
                  return value.split(" ").join("\n");
                },
              },
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Jumlah Pendidik",
              dataIndex: "val",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      jumlahSantri: {
        queryName: "sebaran_jumlah_santri",
        content: {
          title: "Sebaran Jumlah Santri",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik sebaran jumlah santri",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 440,
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            legend: {
              data: ["Santri Mukim", "Santri Non Mukim"],
            },
            xAxis: {
              type: "category",
              data: [],
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                name: "Santri Mukim",
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
              {
                name: "Santri Non Mukim",
                type: "bar",
                itemStyle: {
                  color: "black",
                },
              },
            ],
          },
          columns: [
            {
              title: "Jumlah Santri",
              dataIndex: "total",
            },
            {
              title: "Santri Mukim",
              dataIndex: "santri_mukim",
            },
            {
              title: "Santri Non Mukim",
              dataIndex: "santri_nonmukim",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      kapasitasMasjid: {
        queryName: "sebaran_kapasitas_masjid",
        content: {
          title: "Sebaran Kapasitas Masjid per Unit",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik sebaran kapasitas Masjid per Unit",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: "100%",
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: {
              type: "value",
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                formatter: (value) => {
                  return value.split(" ").join("\n");
                },
              },
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Kapasitas Masjid",
              dataIndex: "val",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      ruangSantri: {
        queryName: "sebaran_kapasitas_ruang_kelas_santri",
        content: {
          title: "Sebaran Kapasitas Ruang Kelas Santri",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan grafik sebaran ruang kelas santri",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 440,
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            legend: {
              data: ["Kelas Santri Putra", "Kelas Santri Putri"],
            },
            xAxis: {
              type: "category",
              data: [],
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                name: "Kelas Santri Putra",
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
              {
                name: "Kelas Santri Putri",
                type: "bar",
                itemStyle: {
                  color: "black",
                },
              },
            ],
          },
          columns: [
            {
              title: "Kapasitas Ruang Kelas Santri",
              dataIndex: "total",
            },
            {
              title: "Kelas Santri Putra",
              dataIndex: "santri_putra",
            },
            {
              title: "Kelas Santri Putri",
              dataIndex: "santri_putri",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      jumlahPerpustakaan: {
        queryName: "sebaran_jumlah_perpustaakaan",
        content: {
          title: "Sebaran Jumlah Perpustakaan",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik sebaran jumlah perpustakaan",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: "100%",
          },
          chartOption: {
            grid: {
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            yAxis: {
              type: "value",
            },
            xAxis: {
              type: "category",
              data: [],
              axisLabel: {
                formatter: (value) => {
                  return value.split(" ").join("\n");
                },
              },
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Jumlah Perpustakaan",
              dataIndex: "sarana_num_perpustakaan",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
      sdmTeknologi: {
        queryName: "jumlah_sumberdaya",
        content: {
          title: "Jumlah Sumber Daya Teknologi Tersedia",
          showTitle: true,
          showSubtitle: false,
          showIcon: false,
          info: "#### Menampilkan statistik jumlah sumber daya teknologi yang tersedia",
          showInfo: true,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
        },
        options: {
          style: {
            height: 450,
          },
          chartOption: {
            grid: {
              top: 20,
              left: 60,
              right: 30,
              bottom: 0,
              containLabel: true,
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            xAxis: {
              type: "value",
            },
            yAxis: {
              type: "category",
              data: [],
            },
            series: [
              {
                type: "bar",
                itemStyle: {
                  color: "#1B6FBD",
                },
              },
            ],
          },
          columns: [
            {
              title: "Sumber Daya Teknologi",
              dataIndex: "sumber_daya_teknologi",
            },
            {
              title: "Jumlah",
              dataIndex: "count",
            },
          ],
          dataSource: [],
        },
        state: {},
      },
    },
  },
};
